import React, { useState } from 'react';
import { LS_MY_TRADES_KEY } from './Table';
import {
  compareNumericString,
  compareTradeDateString,
} from '../../../../helpers/tableSort';

interface ITableWidths {
  ticker: number;
  timestamp: number;
  type: number;
  amountIn: number;
  amountOut: number;
  priceUSD: number;
  valueUSD: number;
  tx: number;
}

// constants
const tableWidthsDefaultState: ITableWidths = {
  ticker: 180,
  timestamp: 150,
  type: 90,
  amountIn: 220,
  amountOut: 220,
  priceUSD: 180,
  valueUSD: 150,
  tx: 120,
};

interface IUseTableDataProps {
  trades: any;
}

const useTableData = ({ trades }: IUseTableDataProps) => {
  const tableWidthsLC = localStorage.getItem(LS_MY_TRADES_KEY);

  const [tableColumnsWidth] = useState(
    tableWidthsLC ? JSON.parse(tableWidthsLC) : tableWidthsDefaultState
  );

  // table memoized required fields
  const data = React.useMemo(() => trades, [trades]);
  const columns = React.useMemo(
    () => [
      {
        id: 'ticker',
        Header: 'Pair',
        accessor: 'ticker',
        disableSortBy: true,
        width: tableColumnsWidth['ticker'] || tableWidthsDefaultState['ticker'],
      },
      {
        id: 'timestamp',
        Header: 'Time',
        accessor: 'timestamp',
        disableSortBy: true,
        width:
          tableColumnsWidth['timestamp'] ||
          tableWidthsDefaultState['timestamp'],
        sortType: compareTradeDateString,
      },
      {
        id: 'type',
        Header: 'Type',
        accessor: 'buy',
        disableSortBy: true,
        width: tableColumnsWidth['type'] || tableWidthsDefaultState['type'],
      },
      {
        id: 'amountIn',
        Header: 'Amount In',
        accessor: 'amount0',
        disableSortBy: true,
        width:
          tableColumnsWidth['amountIn'] || tableWidthsDefaultState['amountIn'],
        sortType: compareNumericString(),
      },
      {
        id: 'amountOut',
        Header: 'Amount Out',
        accessor: 'amount1',
        disableSortBy: true,
        width:
          tableColumnsWidth['amountOut'] ||
          tableWidthsDefaultState['amountOut'],
        sortType: compareNumericString(),
      },
      {
        id: 'priceUSD',
        Header: 'Price USD',
        accessor: 'price_a_usd',
        disableSortBy: true,
        width:
          tableColumnsWidth['priceUSD'] || tableWidthsDefaultState['priceUSD'],
        sortType: compareNumericString(),
      },
      {
        id: 'valueUSD',
        Header: 'Value USD',
        accessor: 'value_usd',
        disableSortBy: true,
        width:
          tableColumnsWidth['valueUSD'] || tableWidthsDefaultState['valueUSD'],
        sortType: compareNumericString(),
      },
      {
        id: 'tx',
        Header: 'Tx Hash',
        accessor: 'tx',
        disableSortBy: true,
        width: tableColumnsWidth['tx'] || tableWidthsDefaultState['tx'],
      },
    ],
    []
  );

  return { columns, data, tableColumnsWidth };
};

export { useTableData };
